import { types } from './actions';

const initialState = {
  isOpen: false,
  quoteItemId: null,
  assemblyParentComponentId: null,
  isSaving: false,
};

const reducer = (state = initialState, action) => {
  const { payload, type } = action;
  switch (type) {
    case types.OPEN:
      return {
        ...state,
        isOpen: true,
        quoteItemId: payload.quoteItemId,
        assemblyParentComponentId: payload.assemblyParentComponentId,
      };
    case types.CLOSE:
      return {
        ...state,
        isOpen: false,
      };
    case types.SUBMIT:
      return {
        ...state,
        isSaving: true,
      };
    case types.SUCCESS:
      return {
        ...state,
        isSaving: false,
        isOpen: false,
      };
    case types.FAILURE:
      return {
        ...state,
        isSaving: false,
        // isOpen: false,
      };
    default:
      return state;
  }
};

const getScope = (state) => state.modules.quotes.replaceParentDrawer;

export const getQuoteItemId = (state) => getScope(state).quoteItemId;

export const getAssemblyParentComponentId = (state) =>
  getScope(state).assemblyParentComponentId;

export const getIsDrawerOpen = (state) => getScope(state).isOpen;

export const getIsSaving = (state) => getScope(state).isSaving;

export default reducer;
